<template>
  <div class="receive-award-wrap">
    <p class="head-tips">
      *以下信息为获奖必须提交的信息内容，仅用于发放奖金，元气桌面不作他用。请于2022年11月20日之前提交完毕，未填写则认为放弃奖励。
      <br>
      *信息若重复提交，则以截止日期的最后一次提交信息为准，如有疑问可联系客服QQ：569865841
    </p>
    <el-form :disabled="hasSubmitted" class="form">
      <h3>个人基础信息</h3>
      <div class="row">
        <label><em class="hl">*</em>真实姓名：</label>
        <el-input v-model="form.real_name" clearable />
      </div>
      <div class="row">
        <label><em class="hl">*</em>手机号码：</label>
        <el-input v-model="form.phone" clearable />
      </div>
      <div class="row">
        <label><em class="hl">*</em>QQ/微信：</label>
        <el-input v-model="form.third_platform_contact" clearable />
      </div>
      <div class="row">
        <label><em class="hl">*</em>证件类型：</label>
        <el-select v-model="form.certificate_type" class="select" placeholder="请选择">
          <el-option label="二代身份证" :value="CertificateTypes.IDCARD" />
          <el-option label="港澳通行证" :value="CertificateTypes.GANGAO_PASSPORT" />
          <el-option label="台湾通行证" :value="CertificateTypes.TAIWAN_PASSPORT" />
          <el-option label="护照" :value="CertificateTypes.PASSPORT" />
        </el-select>
      </div>
      <div class="row">
        <label><em class="hl">*</em>证件号码：</label>
        <el-input v-model="form.certificate_no" clearable />
      </div>
      <!--  -->
      <h3>领奖-银行卡信息</h3>
      <div class="row">
        <label>银行卡号：</label>
        <el-input v-model="form.bank_no" clearable />
      </div>
      <div class="row">
        <label>开户行：</label>
        <el-input v-model="form.bank" clearable />
      </div>
      <div class="row">
        <p class="tips">
          <span class="hl">提示：</span>奖品中含【奖金】项必填，需填写完整支行名，例如中国建设银行深圳科技园支行
        </p>
      </div>
      <template v-if="DELIVER_OPENID.includes(common.open_id)">
        <h3>实物收件信息</h3>
        <div class="row">
          <label><em class="hl">*</em>收件人：</label>
          <el-input v-model="form.deliver_name" clearable />
        </div>
        <div class="row">
          <label><em class="hl">*</em>收件电话：</label>
          <el-input v-model="form.deliver_phone" clearable />
        </div>
        <div class="row">
          <label><em class="hl">*</em>收件地址：</label>
          <el-input v-model="form.deliver_address" clearable />
        </div>
      </template>
    </el-form>
    <button :disabled="hasSubmitted" class="submit-btn" @click="submit">
      {{ hasSubmitted ? '已' : '' }}提交
    </button>
    <ConfirmDialog
      v-if="errorMsg"
      confirm-text="我知道了"
      :text="errorMsg"
      @close="errorMsg = ''"
      @confirm="errorMsg = ''"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CertificateTypes } from '../api/config'
import { fetchAwardeeInfo, fetchIfUserIsAwardee, submitAwardeeInfo } from '@/api/receiveAward'
import ConfirmDialog from '@/components/dialog/ConfirmDialog'

/** 表示剑网 3 壁纸大赛期数 */
const JX3_PERIOD = 7

const defaultForm = {
  real_name: '',
  phone: '',
  certificate_type: CertificateTypes.IDCARD,
  certificate_no: '',
  third_platform_contact: '',
  bank_no: '',
  bank: '',
  deliver_name: '',
  deliver_phone: '',
  deliver_address: '',
}

const DELIVER_OPENID = [
  '1350999187156111360',
  '1328897504486100992',
  '1243168603059785728',

  '1397045717914619904',
  '1401147070152839168',
  '1502646512718188544',
  '1534200774740807680',
  '1362634526467559424',
  '1297469725102182400',
]

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    /** 比赛期数 */
    period: {
      type: Number,
      default: JX3_PERIOD,
    },
  },
  data() {
    return {
      CertificateTypes,
      form: Object.assign({}, defaultForm),
      errorMsg: '',
      /** 是否已提交过 */
      hasSubmitted: false,
      DELIVER_OPENID,
    }
  },
  computed: {
    ...mapState({
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const period = this.period || JX3_PERIOD
      // 先检查是否获奖
      const status = await fetchIfUserIsAwardee({ period })
      if (!status.is_awardee) {
        this.showNotAwardeeTips()
        return
      }
      // 获取之前填写的信息
      const res = await fetchAwardeeInfo({ period })
      if (res) {
        this.form = Object.assign({}, defaultForm, res)
      }
    },
    /** 显示未获奖提示 */
    showNotAwardeeTips() {
      this.errorMsg = '当前用户未获奖'
      // 用户关闭提示弹框后回到首页
      this.$watch('errorMsg', (val) => {
        if (!val) {
          this.$router.replace('/')
        }
      })
    },
    async submit() {
      try {
        await submitAwardeeInfo(this.form, this.period || JX3_PERIOD, {
          needDeliver: DELIVER_OPENID.includes(this.common.open_id),
        })
        this.hasSubmitted = true
      } catch (err) {
        if (typeof err === 'string') {
          this.errorMsg = err
        } else {
          this.errorMsg = err.msg || err.message
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.receive-award-wrap {
  position: relative;
  width: 1200px;
  min-height: 640px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.head-tips {
  margin: 20px;
  margin-bottom: 40px;
  color: #aaa;
  font-size: 14px;
}
.hl {
  font-style: normal;
  color: #f41c83;
}
.form {
  margin: 0 auto;
  width: 600px;
}
.row {
  display: flex;
  align-items: center;
  margin: 10px;
  label {
    width: 130px;
  }
}
.had-commit-tip {
  margin: 20px;
  margin-bottom: 40px;
  color: #aaa;
  font-size: 14px;
  text-align: center;
}
.select {
  width: 100%;
}
.submit-btn {
  outline: 0;
  border: 0;
  display: block;
  user-select: none;
  cursor: pointer;
  margin: 20px auto;
  width: 380px;
  height: 40px;
  color: #333;
  text-align: center;
  line-height: 40px;
  background: #F4C000;
  border-radius: 8px;
  &[disabled] {
    background: #ccc;
    cursor: not-allowed;
  }
  &:hover:not([disabled]) {
    background: #ffda53;
  }
  &:active:not([disabled]) {
    background: #dfaf00;
  }
}
.tips {
  font-size: 14px;
}
</style>
